module.exports = __webpack_public_path__ + "img/error.e5ef2e06.png";